var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "admin-layout",
    {
      attrs: { heading: "Client Hub Dashboard", account: _vm.account },
      scopedSlots: _vm._u([
        {
          key: "side",
          fn: function () {
            return [
              _c(
                "router-link",
                {
                  attrs: {
                    to: "/dashboard/client",
                    "account-id": _vm.account.id,
                  },
                },
                [
                  _c("nav-item", {
                    attrs: { label: "Roadmap", icon: "fas fa-map" },
                  }),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  attrs: {
                    to: "/dashboard/client/notes",
                    "account-id": _vm.account.id,
                  },
                },
                [
                  _c("nav-item", {
                    attrs: { label: "Notes", icon: "fas fa-note-sticky" },
                  }),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  attrs: {
                    to: "/dashboard/client/attachments",
                    "account-id": _vm.account.id,
                  },
                },
                [
                  _c("nav-item", {
                    attrs: { label: "Attachments", icon: "fa fa-paperclip" },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }